import setLoading from "components/loading";
import Upload from 'components/uploader/upload';

const uploadImage = async (localUrls, uuids, file, internalStateSetter, deps) => {
  const upload = new deps.upload(file)
  const reader = new deps.fileReader();
  setLoading(true)
  reader.onload = () => {
    internalStateSetter({ localUrls: [...localUrls, reader.result] })
  };
  reader.readAsDataURL(file);
  await upload.upload()
  internalStateSetter({ uuids: [...uuids, upload.uuid] });
  setLoading(false);

  return { uuids: [...uuids, upload.uuid], localUrls: [...localUrls, reader.result] }
}

let controller = {
  'NoteInput.Wrapper.Wrapper.Input.MentionsInput': ({ value: { action, value, mentioned, personsToMention, uuids, privacy, isEditing } }, outlet, internalStateSetter) => {
    if (action === 'change') {
      internalStateSetter({ inputVal: value, mentioned })
    }
    if (action === 'submit') {
      controller['NoteInput.Wrapper.Wrapper.RightSide.SendIcon']({ value, mentioned, personsToMention, uuids, privacy, isEditing }, outlet, internalStateSetter);
    }
  },

  'NoteInput.Wrapper.ImagesWrapper.UploadButton': async ({ localUrls, uuids, value, deps = { fileReader: FileReader, upload: Upload } }, _, internalStateSetter) => {
    let localUuids = [...uuids];
    let urls = [...localUrls];

    if (value.length > 0) {
      for (let i = 0; i < value.length; i++) {
        let response = await uploadImage(urls, localUuids, value[i], internalStateSetter, deps);
        localUuids = response.uuids;
        urls = response.localUrls;
      }
    }
  },
  'NoteInput.Wrapper.Wrapper.Input.UploadButton': async ({ localUrls, uuids, value, deps = { fileReader: FileReader, upload: Upload } }, _, internalStateSetter) => {
    let localUuids = [...uuids];
    let urls = [...localUrls];

    if (value.length > 0) {
      for (let i = 0; i < value.length; i++) {
        let response = await uploadImage(urls, localUuids, value[i], internalStateSetter, deps);
        localUuids = response.uuids;
        urls = response.localUrls;
      }
    }
  },
  'NoteInput.Wrapper.ImagesWrapper.Image': ({ localUrls, uuids, content_types, localUrlIndex }, _, internalStateSetter) => {

    let newUuids = [...uuids];
    let newLocalUrls = [...localUrls];
    let newContentTypes = [...content_types];

    newUuids.splice(localUrlIndex, 1);
    newLocalUrls.splice(localUrlIndex, 1);
    newContentTypes.splice(localUrlIndex, 1);

    internalStateSetter({ uuids: newUuids, localUrls: newLocalUrls, content_types: newContentTypes });
  },
  'NoteInput.Wrapper.Wrapper.RightSide.SendIcon': ({ value, mentioned, personsToMention, uuids, privacy, isEditing }, outlet, internalStateSetter) => {
    let mentions = personsToMention.filter(p => mentioned.includes(p.id));

    if (!value && uuids.length === 0) {
      if (isEditing) {
        outlet({ value, mentions, uuids, privacy });
        internalStateSetter({ inputVal: '', uuids: [], localUrls: [] });
      }
      return;
    }
    outlet({ value, mentions, uuids, privacy });
    internalStateSetter({ inputVal: '', uuids: [], localUrls: [] });
  },
  'NoteInput.Wrapper.Wrapper.RightSide.PrivacyDropdown': ({ privacy }, _, internalStateSetter) => {
    internalStateSetter({ privacy });
  },
}

export default controller;